// src/features/medicalServices/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import CategoryPage from './pages/mainServices/CategoryPage';
import ServiceItemPage from './pages/serviceItems/ServiceItemsPage';
//import CategoryForm from './pages/categories/CategoryForm';
import ServiceItemForm from './pages/serviceItems/ServiceItemForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';
import CategoryNewForm from './pages/mainServices/NewCategoryForm';

export const medicalServicesRoute = createRoute({
  getParentRoute: () => rootRoute,
    path: '/medical-services',
});

export const medicalServicesCategoriesRoute = createRoute({
  getParentRoute: () => medicalServicesRoute,
    path: '/main-services',
    component: CategoryPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.MEDICALSERVICES.SEARCH_SERVICECATEGORY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const medicalServicesCategoriesFormRoute = createRoute({
    getParentRoute: () => medicalServicesRoute,
    path: '/main-services/form',
    component: CategoryNewForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.MEDICALSERVICES.SAVE_SERVICECATEGORY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const medicalServicesItemsRoute = createRoute({
  getParentRoute: () => medicalServicesRoute,
    path: '/service-items',
    component: ServiceItemPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.MEDICALSERVICES.SEARCH_SERVICECATEGORYITEM || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const medicalServicesCategoriesItemFormRoute = createRoute({
    getParentRoute: () => medicalServicesRoute,
    path: '/service-items/form',
    component: ServiceItemForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.MEDICALSERVICES.SAVE_SERVICECATEGORYITEM || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const medicalServicesRoutes = [
    medicalServicesRoute,
    medicalServicesCategoriesRoute,
    medicalServicesItemsRoute,
    medicalServicesCategoriesFormRoute,
    medicalServicesCategoriesItemFormRoute
];